import React from 'react';
import { useTheme } from '../../themes/ThemeProvider';
import WeatherWidget from './WeatherWidget';
import WeatherWidgetExpandable from './WeatherWidgetExpandable';

const SidebarContextWidget = ({
  currentContext,
  userHomeLocationName,
  userHomeLocationCoords,
  compact = false,  // Added Jan 2026: compact mode for compressed sidebars
  hideLocationName = false,  // Passed through to WeatherWidget — see its own prop doc
  useExpandableWeather = false  // Desktop front page only (29 Jul 2026): swaps WeatherWidget
                                 // for the richer WeatherWidgetExpandable, which owns its own
                                 // card styling (white bg, shadow, radius) — bypasses this
                                 // shell's #edf2f8 background/padding rather than nesting inside it
}) => {
  const themeConfig = useTheme();

  // Adaptive sizing based on compact mode
  const padding = compact ? '8px 8px 4px 16px' : '12px 10px 6px 20px';
  const groupIconSize = compact ? '100px' : '120px';
  const emojiSize = compact ? '40px' : '48px';
  const titleSize = compact ? '14px' : '16px';
  const subtitleSize = compact ? '11px' : '12px';

  const renderContextWidget = () => {
    if (currentContext === 'locality') {
      if (useExpandableWeather) {
        return <WeatherWidgetExpandable locationCoords={userHomeLocationCoords} />;
      }
      return (
        <div style={{
          width: '100%',
          height: '100%',
          padding: padding,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          transition: 'padding 0.3s ease'
        }}>
        <WeatherWidget
          locationName={userHomeLocationName}
          locationCoords={userHomeLocationCoords}
          compact={compact}
          hideLocationName={hideLocationName}
        />
        </div>
      );
    } else {
      // Groups context - show group image placeholder
      return (
        <div style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: padding,
          transition: 'padding 0.3s ease'
        }}>
        {/* Group Image Placeholder */}
        <div style={{
          width: groupIconSize,
          height: groupIconSize,
          backgroundColor: themeConfig.primary,
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: compact ? '12px' : '16px',
          opacity: 0.15,
          transition: 'all 0.3s ease'
        }}>
        <span style={{
          fontSize: emojiSize,
          color: 'white',
          opacity: 0.7,
          transition: 'font-size 0.3s ease'
        }}>👥</span>
        </div>

        <div style={{
          textAlign: 'center',
          color: themeConfig.primary,
          fontFamily: 'OpenSauceSans',
          fontWeight: '900',
          fontSize: titleSize,
          transition: 'font-size 0.3s ease'
        }}>
        Featured Group
        </div>

        <div style={{
          textAlign: 'center',
          color: '#6c757d',
          fontFamily: 'OpenSauceSans',
          fontSize: subtitleSize,
          marginTop: '4px',
          opacity: 0.7,
          transition: 'font-size 0.3s ease'
        }}>
        Community Hub
        </div>
        </div>
      );
    }
  };

  return (
    <div style={{
      width: '100%',
      height: useExpandableWeather ? 'auto' : '100%',
      backgroundColor: useExpandableWeather ? 'transparent' : '#edf2f8',
      borderRadius: useExpandableWeather ? 0 : '12px',
      marginBottom: compact ? '8px' : '12px',
      position: 'relative',
      overflow: useExpandableWeather ? 'visible' : 'hidden',
      transition: 'margin-bottom 0.3s ease'
    }}>
    {renderContextWidget()}
    </div>
  );
};

export default SidebarContextWidget;
